import React from 'react';
import AboutToExpireBody from './AboutToExpireBody';
import { AboutToExpireModalWrapper } from './AboutToExpire.styles';
import AccessTime from '@mui/icons-material/AccessTime';
import Button from '@innovyze/stylovyze/lib/components/Button';
import StylovyzeComposableDialog from '@innovyze/stylovyze/lib/components/StylovyzeComposableDialog';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
import { useAuthProviders, useDispatchLogout, useReauthenticate, } from '@innovyze/stylovyze/lib/hooks/authStates';
import { useReauthSharedWorkerProvider } from '@innovyze/stylovyze/lib/workers/SharedWorkerProvider';
import { AuthType } from '@innovyze/stylovyze/lib/types';
export default function AboutToExpireModal({ open, closeModal, expiryDate, reloadExpiryDate, hasSharedWorkers, }) {
    const { t } = useGlobalization();
    const { reauthenticate } = useReauthenticate();
    const { initializeExtendSession, dispatchCloseSession } = useReauthSharedWorkerProvider();
    const logout = useDispatchLogout();
    const authProvider = useAuthProviders();
    const logoutFn = () => {
        if (hasSharedWorkers) {
            console.warn('LOGIN_V2: AboutToExpireModal - logout ~ shared workers');
            return dispatchCloseSession();
        }
        console.warn('LOGIN_V2: AboutToExpireModal - logout ~ no shared workers');
        logout();
        closeModal();
    };
    return (React.createElement(StylovyzeComposableDialog, { open: open, onCancel: () => void 0, header: React.createElement(AccessTime, { color: "secondary", sx: { fontSize: 40 } }), width: "342px", footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { color: "secondary", onClick: logoutFn }, t('Close Session')),
            React.createElement(Button, { color: "secondary", variant: "contained", onClick: async () => {
                    if (hasSharedWorkers) {
                        if (authProvider === AuthType.Auth0) {
                            await reauthenticate();
                        }
                        return initializeExtendSession();
                    }
                    await reauthenticate();
                    reloadExpiryDate();
                    closeModal();
                } }, t('Extend Session'))) },
        React.createElement(AboutToExpireModalWrapper, null,
            React.createElement(AboutToExpireBody, { expiryDate: expiryDate, logout: logoutFn }))));
}
